import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { Registrar } from 'src/app/models/registrar.model';
import { ContactService } from 'src/app/services/contact.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { TerminosYCondicionesModalComponent } from './terminos-ycondiciones-modal/terminos-ycondiciones-modal.component';
import { NewRegistrationService } from 'src/app/services/new-registration.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {

  // Modales
  @ViewChild(TerminosYCondicionesModalComponent, { static: true }) modalTerminosYCondiciones: TerminosYCondicionesModalComponent

  guardar = false;
  siteKey: string;
  progress = false;
  MensajeError = false;
  MensajeSucces = false;
  buscando = false;
  buscandoError = false;
  Yaexiste = false;
  duplicado = false;
  ContactForm: FormGroup;
  validarionsRut: any;
  MensajeErrorBloqueoFinanciero = false;
  MensajeNoAceptaTerminos = false;

  private guid: string = ''
  progressValidacion: boolean = false
  resultadoPreValidacionClave: any = null
  allowInteract: boolean = false

  mensajes = {
    showEnListaEspera: false,
    showSeleccionado: false,
    showErrorValidacion: false,
    showTokenExpirado: false,
    tokenExpirado: ''
  }
  showForm: boolean = false

  rut = false;
  nombre = false;
  nombre2 = false;

  disableRut = false

  private rutValidator: RutValidator
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private contact: ContactService,
    rutValidator: RutValidator,
    private alerts: ToastrService,
    private auth: AuthService,
    private newRegistrationService: NewRegistrationService
  ) {
    this.siteKey = '6LfxwdQZAAAAANiJELiajiQagFv1tsWk9a4Gr6wX';
    this.rutValidator = rutValidator
  }

  ngOnInit(): void {
    console.log('[REGISTER] ngOnInit')
    this.createForm();

    this.activatedRoute.params.subscribe(
      param => {
        console.log('[REGISTER]', param.guid)
        this.guid = param.guid
        this.validateGuid(this.guid)
      },
    );

    this.enableFormData(false);

    this.ContactForm.controls.Clave.markAsTouched();
  }

  createForm() {
    this.validarionsRut = this.rutValidator;
    this.ContactForm = this.fb.group(
      {
        Nombre: [
          '',
          [
            Validators.required,
            Validators.maxLength(60),
            Validators.minLength(3),
          ],
        ], // , Validators.pattern(onleLettersAndSpacePattern)
        Nombre2: ['', [Validators.maxLength(60), Validators.minLength(3)]],
        ApellidoP: [
          '',
          [
            Validators.required,
            Validators.maxLength(50),
            Validators.minLength(3),
          ],
        ], // , Validators.pattern(onleLettersAndSpacePattern)
        ApellidoM: ['', [Validators.maxLength(50), Validators.minLength(3)]], // , Validators.pattern(onleLettersAndSpacePattern)
        RUT: [
          '',
          [
            Validators.required,
            Validators.maxLength(50),
            this.validarionsRut,
            Validators.minLength(3),
          ],
        ],
        Passaporte: [''],
        Correo: [
          '',
          [
            Validators.email,
            Validators.required,
            Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
          ],
        ],
        Correo2: [
          '',
          [
            Validators.email,
            Validators.required,
            Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
          ],
        ],
        Telefono: [
          '',
          [
            Validators.required,
            Validators.maxLength(9),
            Validators.minLength(9),
          ],
        ],
        // Telefono: ['', [Validators.pattern(/^([(]{1}[2]{1}[)]{1}\s[0-9]{8})$/)]],
        //Clave: ['', [Validators.required, Validators.maxLength(16), Validators.minLength(3), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$.$-$,$!%*?&])([A-Za-z\d$@$!%*?&]|[^ ]){8,16}$/)]],
        Clave: [
          '',
          [
            Validators.required,
            Validators.maxLength(16),
            Validators.minLength(3),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-$@$.$-$,$!%*?&])([A-Za-z\d-$@$!%*?&]|[^ ]){8,16}$/
            ),
          ],
        ],
        Clave2: [
          '',
          [
            Validators.required,
            Validators.maxLength(16),
            Validators.minLength(3),
          ],
        ],
        Nacionalidad: ['1'],
        Captcha: ['', Validators.required],
        Aceptaterminos: [false],
      },
      {
        validators: [
          this.ClavesIguales('Clave', 'Clave2'),
          this.ClavesIguales('Correo', 'Correo2'),
        ],
      }
    );

    this.enableFormData(false);
  }

  async validateGuid(guid: string) {
    this.buscando = true
    this.newRegistrationService.ValidarGuid(guid).subscribe(
      (data: any) => {
        this.buscando = false
        console.log('[REGISTER] validateGuid', data)

        if (data.length > 0) {
          console.log('existe postulaciones rut data.length > 0', data)

          this.showForm = true

          const registro = data[0]

          if (registro.esPasaporte) {
            this.ContactForm.get('Nacionalidad').setValue('2')
            this.ContactForm.get('Passaporte').setValue(registro.rut);
            this.ContactForm.get('Passaporte').disable();
            this.mensajes.showSeleccionado = true
          } else {
            this.ContactForm.get('Nacionalidad').setValue('1')
            this.ContactForm.get('RUT').setValue(registro.rut + registro.dv);
            this.ContactForm.get('RUT').disable();
          }

          this.ContactForm.controls['Nombre'].setValue(
            registro.Nombres?.split(' ')[0]
          );
          if (registro.Nombres?.split(' ').length > 1) {
            this.ContactForm.controls['Nombre2'].setValue(
              registro.Nombres?.split(' ')[1]
            );
          }
          if (registro.Email === null) {
            registro.Email = '';
          }
          if (registro.Email.length > 5) {
            this.ContactForm.controls['Correo'].setValue(registro.Email);
            this.ContactForm.controls['Correo2'].setValue(registro.Email);
          }
          this.ContactForm.controls['ApellidoP'].setValue(registro.APaterno);
          this.ContactForm.controls['ApellidoM'].setValue(registro.AMaterno);
          this.ContactForm.controls['Telefono'].setValue(registro.Celular);
        } else {
          //mensaje
          this.buscandoError = true;
          this.ContactForm.controls['Clave'].enable();
          this.ContactForm.controls['Clave2'].enable();
          this.ContactForm.controls['Aceptaterminos'].enable();
        }
        this.buscando = false;
      },
      (err) => {
        console.log('[REGISTER] Error en ExistePostulacionRut', err.status, err)
        if (err.status === 401) {
          this.mensajes.showTokenExpirado = true
          this.buscando = false
          setTimeout(() => {
            this.router.navigate(['/']);
          }, 9000);
          return
        }
        this.alerts.info(
          'De acuerdo a nuestros registros no estás seleccionado en ninguna de nuestras carreras adscritas',
          'Proceso de Admisión Centralizada DEMRE'
        );
        setTimeout(() => {
          this.router.navigate(['/']);
        }, 9000);
        this.buscando = false;
        this.ContactForm.controls['Clave'].enable();
        this.ContactForm.controls['Clave2'].enable();
        this.ContactForm.controls['Aceptaterminos'].enable();
        this.buscandoError = true;
      }
    );
  }

  validacionFallida(mensaje) {
    console.log('validación fallida', mensaje);
  }

  enableFormData(enable: boolean = true) {
    console.log('[REGISTER] enableFormData', enable)
    if (enable) {
      this.ContactForm.controls['Nacionalidad'].enable();
      this.ContactForm.controls['RUT'].enable();
      this.ContactForm.controls['Passaporte'].enable();
      this.ContactForm.controls['Nombre'].enable();
      this.ContactForm.controls['Nombre2'].enable();
      this.ContactForm.controls['ApellidoP'].enable();
      this.ContactForm.controls['ApellidoM'].enable();
      this.ContactForm.controls['Telefono'].enable();
      this.ContactForm.controls['Correo'].enable();
      this.ContactForm.controls['Correo2'].enable();
    } else {
      this.ContactForm.controls['Nacionalidad'].disable();
      this.ContactForm.controls['RUT'].disable();
      this.ContactForm.controls['Passaporte'].disable();
      this.ContactForm.controls['Nombre'].disable();
      this.ContactForm.controls['Nombre2'].disable();
      this.ContactForm.controls['ApellidoP'].disable();
      this.ContactForm.controls['ApellidoM'].disable();
      this.ContactForm.controls['Telefono'].disable();
      this.ContactForm.controls['Correo'].disable();
      this.ContactForm.controls['Correo2'].disable();
    }
  }

  clearMensajes() {
    if (!this.mensajes) return
    this.mensajes.showEnListaEspera = false
    this.mensajes.showSeleccionado = false
  }

  resolved(captchaResponse: string) {
    console.log('Resolved captcha.');
  }

  ClavesIguales(pass1Name: string, pass2Name: string) {
    console.log('[REGISTER] ClavesIguales', pass1Name, pass2Name)
    return (formGroup: FormGroup) => {
      const pass1Control = formGroup.get(pass1Name);
      const pass2Control = formGroup.get(pass2Name);

      if (pass1Control.value === pass2Control.value) {
        pass2Control.setErrors(null);
      } else {
        pass2Control.setErrors({ noEsIgual: true });
      }
    };
  }

  async ChangeCorreo(event: any) {
    console.log('[REGISTER] ChangeCorreo')
    this.contact
      .ValidaExisteCorreo(this.ContactForm.controls.Correo.value)
      .subscribe(
        (data: any) => {
          if (data.Result) {
            this.alerts.info(
              'El correo electrónico ingresado ya existe, recupere su contraseña para poder acceder al portal.',
              'Servicio de registro'
            );
            this.ContactForm.controls.Correo.setValue('');
          }
        },
        (err) => {
          this.alerts.warning(
            'El servicio no se encuentra operativo, comunicar via chat',
            'Servicio de registro'
          );
        },
        () => {
          this.duplicado = false;
        }
      );
  }

  OpenModal() {
    console.log('[REGISTER] openModal')
    this.validateAllFormFields(this.ContactForm);
    if (this.ContactForm.valid) {
      this.modalTerminosYCondiciones.OpenModal()
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    console.log('[REGISTER] validateAllFormFields', formGroup.value)
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  SendFormContact(acepta: boolean) {
    console.log('[REGISTER] SendFormContact', acepta)
    if (!acepta) {
      this.MensajeNoAceptaTerminos = true;
      setTimeout(() => {
        this.MensajeNoAceptaTerminos = false;
        this.router.navigateByUrl('/');
      }, 7000);
      return
    }

    this.validateAllFormFields(this.ContactForm);
    this.ContactForm.controls.Aceptaterminos.setValue(acepta);
    if (this.ContactForm.valid) {
      this.guardar = true;
      this.progress = true;
      this.enableFormData()
      const registro = new Registrar(this.ContactForm.value);
      this.enableFormData(false)
      this.contact.SendPersona(registro).subscribe(
        (data: any) => {
          if (data.Error) {
            console.log('[REGISTER] data con errores', data.Error)
            this.progress = false;
            this.guardar = false;
            this.Yaexiste = true;
            this.alerts.info(data.MensajeRetorno, 'Estimado Postulante');
            setTimeout(() => {
              this.router.navigateByUrl('/');
            }, 10000);
            return
          }
          // else
          {
            if (data.AceptaTerminos == false) {
              this.MensajeNoAceptaTerminos = true;
              setTimeout(() => {
                this.MensajeNoAceptaTerminos = false;
                this.router.navigateByUrl('/');
              }, 7000);
            } else {
              console.log('[REGISTER] seguir el flujo')
              this.MensajeErrorBloqueoFinanciero = false;
              this.MensajeNoAceptaTerminos = false;
              this.MensajeSucces = true;
              this.ContactForm.reset();
              setTimeout(() => {
                this.MensajeSucces = false;
                this.router.navigateByUrl('/');
              }, 7000);
            }
          }
        },
        (errs) => {
          this.progress = false;
          this.guardar = false;
          this.MensajeError = true;
          setTimeout(() => {
            this.MensajeError = false;
          }, 7000);
        }
      );
    } else {
      ///alert('Formulario no valido... Creacion del Registro');
    }
  }

  returnToLogin() {
    this.router.navigateByUrl('/');
  }
}
